import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-signed-out',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './signed-out.component.html'
})
export class SignedOutComponent implements OnInit, OnDestroy {

  constructor(
    private titleService: Title,
    private translateService: TranslateService) { }

  ngOnInit() {
    document.body.classList.add('background');
    this.titleService.setTitle(`${this.translateService.instant('pages.signed-out-title')} | ${environment.appName}`);
  }

  ngOnDestroy() {
    document.body.classList.remove('background');
  }

}
